import React from 'react';
import { ReactComponent as Home } from './icon/Home.svg';
import { ReactComponent as Link } from './icon/Link.svg';
import { ReactComponent as Card } from './icon/Card.svg';
import { ReactComponent as Bill } from './icon/Bill.svg';
import { ReactComponent as Click } from './icon/Click.svg';
import { ReactComponent as Coin } from './icon/Coin.svg';
import { ReactComponent as Creatives } from './icon/Creatives.svg';
import { ReactComponent as Money } from './icon/Money.svg';
import { ReactComponent as Balance } from './icon/Balance.svg';
import { ReactComponent as User } from './icon/User.svg';
import { ReactComponent as Eye } from './icon/Eye.svg';
import { ReactComponent as Copy } from './icon/Copy.svg';
import { ReactComponent as UserStar } from './icon/User-star.svg';
import { ReactComponent as Image } from './icon/Image.svg';
import { ReactComponent as Profile } from './icon/Profile.svg';
import { ReactComponent as Docs } from './icon/Docs.svg';

const MyIcon = ({ name, color, fill }) => {
  let Icon = <div></div>;
  switch (name) {
    case 'home':
      Icon = Home;
      break;
    case 'link':
      Icon = Link;
      break;
    case 'card':
      Icon = Card;
      break;
    case 'money':
      Icon = Money;
      break;
    case 'click':
      Icon = Click;
      break;
    case 'creatives':
      Icon = Creatives;
      break;
    case 'bill':
      Icon = Bill;
      break;
    case 'user':
      Icon = User;
      break;
    case 'coin':
      Icon = Coin;
      break;
    case 'balance':
      Icon = Balance;
      break;
    case 'copy':
      Icon = Copy;
      break;
    case 'eye':
      Icon = Eye;
      break;
    case 'user-star':
      Icon = UserStar;
      break;
    case 'image':
      Icon = Image;
      break;
    case 'profile':
      Icon = Profile;
      break;
    case 'docs':
      Icon = Docs;
      break;
    default:
  }
  return <Icon stroke={color || 'currentColor'} fill={fill || 'none'} />;
};

export default MyIcon;
